<!-- Multi-entry attribute display -->
<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

const props = defineProps({
  attribute: {
    type: Object,
    required: true,
  },
});

const { t } = useI18n();

const entries = computed(() => {
  const value = props.attribute.value;
  return Array.isArray(value) ? value : [];
});

const hasEntries = computed(() => entries.value.length > 0);

const formatEntryDate = dateStr => {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleDateString();
};
</script>

<template>
  <div class="flex flex-col w-full min-w-0 gap-1">
    <div v-if="hasEntries" class="flex flex-col gap-1">
      <div
        v-for="(entry, idx) in entries"
        :key="idx"
        class="text-sm text-n-slate-11 py-1"
      >
        <p class="mb-0 break-words">{{ entry.text }}</p>
        <span
          v-if="entry.expires_at"
          class="text-xs"
          :class="
            new Date(entry.expires_at) <= new Date()
              ? 'text-n-ruby-9'
              : 'text-n-amber-9'
          "
        >
          {{
            t('CUSTOM_ATTRIBUTES.MULTI_ENTRY.EXPIRES_ON', {
              date: formatEntryDate(entry.expires_at),
            })
          }}
        </span>
        <span
          v-if="entry.remove_labels && entry.remove_labels.length"
          class="flex items-center gap-1 text-xs text-n-slate-9 mt-0.5"
        >
          <span class="i-lucide-tag size-3 flex-shrink-0" />
          {{
            t('CUSTOM_ATTRIBUTES.MULTI_ENTRY.REMOVE_LABEL_ON_EXPIRE', {
              label: entry.remove_labels.join(', '),
            })
          }}
        </span>
        <span
          v-if="entry.add_labels && entry.add_labels.length"
          class="flex items-center gap-1 text-xs text-n-slate-9 mt-0.5"
        >
          <span class="i-lucide-arrow-right-left size-3 flex-shrink-0" />
          {{
            t('CUSTOM_ATTRIBUTES.MULTI_ENTRY.ADD_LABEL_ON_EXPIRE', {
              label: entry.add_labels.join(', '),
            })
          }}
        </span>
      </div>
    </div>
    <span v-else class="text-sm text-n-slate-11">{{
      t('CONTACTS_LAYOUT.SIDEBAR.ATTRIBUTES.TRIGGER.INPUT')
    }}</span>
  </div>
</template>
